import { NgModule } from '@angular/core';
import { NUMERAL_PROVIDERS } from './numeral.component';

@NgModule({
 imports: [],
 exports: [],
 declarations: [],
 providers: [ NUMERAL_PROVIDERS],
})

export class NumeralModule { }
